import { ColumnsType } from "antd/es/table";
import { TableButton } from "shared/ui";

interface useGetReportCategoriesColumnsProps {
  handleEditReport: (record: { id: number; name: string }) => void;
  showDeleteReportCategoryModal: (record: { id: number; name: string }) => void;
}

export const useGetReportCategoriesColumns = ({
  handleEditReport,
  showDeleteReportCategoryModal,
}: useGetReportCategoriesColumnsProps): ColumnsType<{
  id: number;
  name: string;
}> => [
  {
    key: "sort",
    width: "2%",
    align: "center",
    render: () => <span style={{ color: "#999", fontSize: 18 }}>⋮⋮</span>,
  },
  {
    title: "Ordering",
    key: "order",
    width: "5%",
    dataIndex: "order",
    render: (value: number) => <span>{value}</span>,
  },
  {
    title: "Name",
    key: "name",
    width: "80%",
    dataIndex: "name",
    render: (value: string) => <span>{value}</span>,
  },
  {
    title: "Actions",
    width: "5%",
    render: (report) => (
      <div className="flex items-center gap-2">
        <TableButton type="edit" onClick={() => handleEditReport(report)} />
        <TableButton
          type="delete"
          onClick={() => showDeleteReportCategoryModal(report)}
        />
      </div>
    ),
  },
];
